export var ShowVerticalSectionCommand = function(eventArg) {
  this.showVerticalSection = eventArg;
}
ShowVerticalSectionCommand.prototype = {
  constructor: ShowVerticalSectionCommand,
  exec: function(vueScope) {
    if (this.showVerticalSection) {
      $('#verticalTransect').show();
    } else {
      $('#verticalTransect').hide();
    }
  }

}


// WEBPACK FOOTER //
// ./src/plugins/components/Web3dModels/commands/ShowVerticalSectionCommand.js